import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InitializeUsercentricsDirective } from './initialize-usercentrics.directive';



@NgModule({
    declarations: [InitializeUsercentricsDirective],
    exports: [
        InitializeUsercentricsDirective
    ],
    imports: [
        CommonModule
    ]
})
export class CookieConsentModule { }
